import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="footer-wrap">
      <ul className="footer">
        {/* HOME */}
        <li
          className={`footer-item ${location.pathname === "/" ? "active" : ""}`}>
          <Link to="/" className="footer-link">
            <i className="iconly-Home icli"></i>
            <span>Home</span>
          </Link>
        </li>

        {/* CATEGORY */}
        <li
          className={`footer-item ${location.pathname === "/category" ? "active" : ""}`}>
          <Link to="/category" className="footer-link">
            <i className="iconly-Category icli"></i>
            <span>Category</span>
          </Link>
        </li>

        {/* SEARCH */}
        <li
          className={`footer-item ${location.pathname === "/search" ? "active" : ""}`}>
          <Link to="/search" className="footer-link">
            <i className="iconly-Search icli"></i>
            <span>Search</span>
          </Link>
        </li>

        {/* OFFERS */}
        <li
          className={`footer-item ${location.pathname === "/offers" ? "active" : ""}`}>
          <Link to="/offers" className="footer-link">
            <span className="offer">🎁</span>
            <span>Offers</span>
          </Link>
        </li>

        {/* CART */}
        <li
          className={`footer-item ${location.pathname === "/cart" ? "active" : ""}`}>
          <Link to="/cart" className="footer-link">
            <i className="iconly-Bag-2 icli"></i>
            <span>Cart</span>
          </Link>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
